import React, { useState } from "react";
import AlertModal from "./AlertModel";


const MyForm = () => {
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // your API call or form submission logic here
      throw new Error("Server not responding"); // just for testing
    } catch (err) {
      console.error("Error submitting form:", err);

      // set error message for modal
      setErrorMsg(err.message || "Unknown error occurred");
      setOpen(true);

      // Debug: see all keys of error object
      if (err && typeof err === "object") {
        Object.keys(err).forEach((key) => {
          console.log(`${key}:`, err[key]);
        });
      }
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit} className="mt-16 min-h-full flex justify-center" >
        <button
          type="submit"
          className="px-6 my-16 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700"
        >
          Submit
        </button>
      </form>

      {/* Alert modal */}
      <AlertModal
        isOpen={open}
        onClose={() => setOpen(false)}
        title="Error!"
        message={`Error submitting form: ${errorMsg}`}
        type="error"
      />
    </div>
  );
};

export default MyForm;
